module.exports = __webpack_public_path__ + "static/media/practice_version_2.2.da643865.png";